import { render, staticRenderFns } from "./dept_tree_table.vue?vue&type=template&id=71513fca&"
import script from "./dept_tree_table.vue?vue&type=script&lang=js&"
export * from "./dept_tree_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports